import React, { ReactNode } from 'react';
import { connect } from 'react-redux';

import Footer from 'components/Footer/Footer';
import { ReduxState } from 'kb-redux';
import { KindbodyLogo } from 'layouts/MainLayout/Logo/KindBodyLogo';
import { NavigationContainer } from 'layouts/MainLayout/Navigation/NavigationContainer/NavigationContainer';
import { MAIN_CONTENT_ID, SkipToMainContent } from 'layouts/SkipToMainContent';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const Main = styled.main<{ $isLoggedIn: IsLoggedInType }>`
  margin: 0 10px 80px 0;

  @media ${({ theme }) => theme.queries.minDesktop} {
    ${({ $isLoggedIn }) => `
    margin: ${$isLoggedIn ? `0 0 80px 80px` : `0 0 80px 0`};
  `}
  }
  flex: 1 0 auto;
`;

const StickyBottom = styled.div<{ $isLoggedIn: IsLoggedInType }>`
  flex-shrink: 0;
  @media ${({ theme }) => theme.queries.minLargeDesktop} {
    ${({ $isLoggedIn }) => `
    margin-left: ${$isLoggedIn ? `80px` : `0`};
  `}
  }
`;

type IsLoggedInType = boolean | undefined;

interface Props {
  children: ReactNode;
  isLoggedIn: IsLoggedInType;
  isNotFoundPage?: boolean;
}

const SimpleLayout = (props: Props) => {
  const { children, isLoggedIn, isNotFoundPage } = props;

  return (
    <Container>
      <SkipToMainContent />
      {!isLoggedIn && (
        <KindbodyLogo href="https://kindbody.com/" aria-label="Kindbody website" marginTop="40" />
      )}
      <NavigationContainer />
      <Main id={MAIN_CONTENT_ID} tabIndex={-1} $isLoggedIn={isLoggedIn}>
        {children}
      </Main>
      <StickyBottom $isLoggedIn={isLoggedIn}>
        <Footer fixed={true} isNotFoundPage={isNotFoundPage} />
      </StickyBottom>
    </Container>
  );
};

const mapStateToProps = ({ patient: { isLoggedIn } }: ReduxState) => ({
  isLoggedIn: isLoggedIn
});

export const ConnectedSimpleLayout = connect(mapStateToProps, null)(SimpleLayout);
